// Shared by React and the static HTML generator: one source for every route.
const content = require('../assets/siteContent.json');
const properties = Object.values(require('../assets/gitesStruct.json'));
const absolute = value => new URL(value, content.site.url).href;
const propertyPath = gite => '/hebergement-a-marie-galante/' + gite.url_folder;
const routes = ['/', '/nos-tarifs', '/nos-videos', '/contact', ...properties.map(propertyPath)];
const pageKeys = { '/': 'home', '/nos-tarifs': 'rates', '/nos-videos': 'videos', '/contact': 'contact' };

function getSeo(pathname) {
  const route = pathname.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  const gite = properties.find(item => propertyPath(item) === route);
  const meta = gite ? {
    title: content.pages.property.metaTitle.replace('{name}', gite.presentation.nom),
    description: gite.presentation.description
  } : content.pages[pageKeys[route] || 'home'].meta;
  const url = absolute(routes.includes(route) ? route : '/');
  const organizationId = absolute('/#organization');
  const graph = [{
    '@type': 'Organization', '@id': organizationId,
    name: content.site.name, url: absolute('/'),
    telephone: content.site.phone.href.replace('tel:', ''),
    image: absolute(content.site.socialImage)
  }, {
    '@type': 'WebSite', '@id': absolute('/#website'),
    url: absolute('/'), name: content.site.name,
    inLanguage: content.locale, publisher: { '@id': organizationId }
  }, {
    '@type': route === '/contact' ? 'ContactPage' : 'WebPage',
    '@id': url + '#webpage', url, name: meta.title + ' | ' + content.site.name,
    description: meta.description, inLanguage: content.locale,
    isPartOf: { '@id': absolute('/#website') }, about: { '@id': organizationId }
  }];
  const shownProperties = gite ? [gite] : route === '/' ? properties : [];
  for (const item of shownProperties) {
    graph.push({
      '@type': 'LodgingBusiness', '@id': absolute(propertyPath(item)) + '#lodging',
      name: item.presentation.nom, url: absolute(propertyPath(item)),
      description: item.presentation.description, image: absolute(item.image),
      address: item.adresse, telephone: content.site.phone.href.replace('tel:', ''),
      parentOrganization: { '@id': organizationId },
      geo: { '@type': 'GeoCoordinates', latitude: item.maps.center.lat, longitude: item.maps.center.lng }
    });
  }
  if (route !== '/' && routes.includes(route)) graph.push({
    '@type': 'BreadcrumbList', itemListElement: [
      { '@type': 'ListItem', position: 1, name: content.navigation.home, item: absolute('/') },
      { '@type': 'ListItem', position: 2, name: gite ? gite.presentation.nom : meta.title, item: url }
    ]
  });
  return { title: meta.title + ' | ' + content.site.name, description: meta.description,
    url, image: absolute(gite ? gite.image : content.site.socialImage),
    structuredData: { '@context': 'https://schema.org', '@graph': graph } };
}

// Safe for embedding in HTML script elements, including future editorial content.
const serializeJsonLd = value => JSON.stringify(value).replace(/</g, '\\u003c');
module.exports = { getSeo, routes, serializeJsonLd };
